<template>
  <div class="center">
    <!--div class="fixation" -->
      <img src="../assets/optimal_fixation.png" />
    <!-- /div -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import State from '../mixins/State'
import _ from 'lodash'
import * as Mousetrap from 'mousetrap'
export default {
  mixins: [ State ],
  data: () => {
    return {
      timer: undefined,
      keyCode: undefined,
      responded: false,
      timeout: false,
      start_time: undefined,
      response_time: null,
      end_time: undefined,
      page: undefined
    }
  },
  computed: {
    ...mapState({
      cue_response_bucket: state => state.parameters.cue_response_bucket,
      cue_duration: state => state.parameters.cue_duration,
      cue_fixation_duration: state => state.parameters.cue_fixation_duration,
      probe_duration: state => state.parameters.probe_duration,
      probe_response_bucket: state => state.parameters.probe_response_bucket,
      probe_fixation_duration: state => state.parameters.probe_fixation_duration,
      outcome_duration: state => state.parameters.outcome_duration,
      outcome_fixation_duration: state => state.parameters.outcome_fixation_duration,
      intertrial_start_time: state => state.intertrial_start_time,
      temp_remaining_time: state => state.temp_remaining_time,
      trials: state => state.trials,
      blocksCompleted: state => state.blocksCompleted,
      blocks: state => state.parameters.blocks
    })
  },
  mounted () {
    this.page = this.$route.params.page
    this.start_time = Date.now()

    // set a timer that will navigate to the next state
    if (this.page === 'cue') {
      if (this.temp_remaining_time > 0) { // responded earlier
        this.responded = true
      }

      this.timer = setTimeout(() => {
        if (!this.responded) {
          this.timeout = true
        }
        this.$router.replace('/probe')
      }, this.cue_fixation_duration)

      Mousetrap.bind(['left', 'right'], _.once((e) => {
        // if didn't respond in cue and response within allowable response bucket
        // cue focus is not allowed to end early, so wait for timeout
        this.response_time = Date.now() - this.start_time
        if (this.temp_remaining_time === 0 && (Date.now() - this.start_time <= this.cue_response_bucket - this.cue_duration)) {
          this.keyCode = e.keyCode
          this.responded = true
        }
      }))
    } else if (this.page === 'probe') {
      if (this.temp_remaining_time > 0) { // responded earlier
        this.responded = true
      }

      this.timer = setTimeout(() => {
        if (!this.responded) {
          this.timeout = true
        }
        this.$router.replace('/outcome')
      }, this.probe_fixation_duration)

      Mousetrap.bind(['left', 'up', 'right'], _.once((e) => {
        this.response_time = Date.now() - this.start_time
        if (this.temp_remaining_time === 0 && (Date.now() - this.start_time <= this.probe_response_bucket - this.probe_duration)) {
          this.keyCode = e.keyCode
          this.responded = true
        }
        // commenting the following back in to ensure probe focus is no longerfixed duration, but is jittered, like the cue
        this.$router.replace('/outcome')
      }))
    } else if (this.page === 'outcome') {
      // show final focus for the remainder of the time
      const trialDuration = this.cue_duration + this.cue_fixation_duration + this.probe_duration + this.probe_fixation_duration + this.outcome_duration + this.outcome_fixation_duration
      let remaining_time = trialDuration - (Date.now() - this.intertrial_start_time) // amount time remining to get 4800 ms per trial
      if (remaining_time < 0) {
        remaining_time = 0
      }
      this.timer = setTimeout(() => {
        if (this.trials.length > 0) {
          this.$router.replace('/cue')
        } else {
          this.nextBlock() // go to the next block
          if (this.blocksCompleted >= this.blocks) {
            // if all blocks are now completed, go to complete state
            this.end()
            this.$router.replace('/complete')
          } else {
            // if more blocks, go the next block state
            this.$router.replace('/block')
          }
        }
      }
      , remaining_time)
      this.$store.commit('clearRemainingTime')
    }
  },
  beforeDestroy () {
    // clear the timer when the focus state is left
    clearTimeout(this.timer)
    Mousetrap.unbind(['left', 'right'])
    this.end_time = Date.now()
    if (this.page === 'cue') {
      if (this.timeout) {
        this.response({ r: 'timeout', remaining_time: 0, start_time: this.start_time, response_time: this.response_time, end_time: this.end_time, response_state: 'cue_focus' })
      } else {
        // remaining time is 0 because focus will be shown to full
        this.response({ r: this.keyCode, remaining_time: 0, start_time: this.start_time, response_time: this.response_time, end_time: this.end_time, response_state: 'cue_focus' })
      }
    } else if (this.page === 'probe') {
      if (this.timeout) {
        this.response({ r: 'timeout', remaining_time: 0, start_time: this.start_time, response_time: this.response_time, end_time: this.end_time, response_state: 'probe_focus' })
      } else {
        this.response({ r: this.keyCode, remaining_time: this.probe_fixation_duration - (this.end_time - this.start_time), start_time: this.start_time, response_time: this.response_time, end_time: this.end_time, response_state: 'probe_focus' })
      }
    } else if (this.page === 'outcome') {
      // intertrial focus
      this.response({ r: null, remaining_time: 0, start_time: this.start_time, response_time: this.response_time, end_time: this.end_time, response_state: 'outcome_focus' })
      this.next() // set the next trial
    }
  },
  methods: {
    ...mapActions(['response', 'setStartTime', 'next', 'nextBlock', 'end'])
  }
}
</script>
